import { Injectable } from '@angular/core';
import * as URL from '../../routes';
import { AuthenticationService } from '../authentication.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Anomaly } from '../../_models/anomaly.model';

@Injectable({
  providedIn: 'root'
})
export class AnomalyService {

  constructor(
    private httpClient: HttpClient,
    private authService: AuthenticationService,
  ) { }

  async uploadAnomaly(formData): Promise<any> {
    if (this.authService.isLogged()) {
      return await this.httpClient.post(URL.ROUTE_ANOMALY, formData, {
        reportProgress: false,
        observe: 'events'
      }).toPromise();
    } else {
      return false;
    }
  }

  public async editAnomaly(id: number, data): Promise<any> {
    if (this.authService.isLogged()) {
      return await this.httpClient
        .put(URL.ROUTE_ANOMALY + '/' + id, data)
        .toPromise();
    } else {
      return false;
    }
  }

  public getAnomalies(): Observable<Array<Anomaly>> {
    return this.httpClient.get<Array<Anomaly>>(URL.ROUTE_ANOMALY);
  }

  public getAnomaly(id): Observable<Anomaly> {
    return this.httpClient.get<Anomaly>(URL.ROUTE_ANOMALY + '/' + id);
  }

  public async delete(id): Promise<any> {
    if (this.authService.isLogged()) {
      return await this.httpClient
        .delete(URL.ROUTE_ANOMALY + '/' + id)
        .toPromise();
    } else {
      return false;
    }
  }
}
